import * as types from 'src/store/types';
import app from 'src/main'

export default {
  load(context, payload) {
    app.$language.current = payload
  }
};
